import React from 'react';

import { Accent } from 'components/TextBlock/TextBlock.styles';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import { BrandTiktokIcon } from '@zola/zola-ui/src/components/SvgIconsV3/BrandTiktok';
import { BrandInstagramIcon } from '@zola/zola-ui/src/components/SvgIconsV3/BrandInstagram';

import { HedWrapper } from '@zola/zola-ui/src/components/PreAuthV3/CategoryTiles.styles';

import { desktopOnly, excludeDesktop } from '@zola/zola-ui/src/styles/emotion/mixins/responsive';
import { CategoryScroller } from '@zola/zola-ui/src/components/PreAuthV3/CategoryTiles';

import {
  Container,
  ButtonsContainer,
  Tile,
  marginRight,
  StyledH3,
} from './SocialMediaSection.styles';
import imageData from './images';

type SocialMediaSectionProps = {
  className?: string;
};

const SocialMediaSection = ({ className }: SocialMediaSectionProps): JSX.Element => {
  const renderButtons = () => (
    <ButtonsContainer>
      <ButtonV3
        component="a"
        href="https://www.tiktok.com/@zola"
        textTransform={false}
        target="_blank"
        rel="noopener noreferrer"
        size="large"
      >
        <BrandTiktokIcon width={20} height={20} css={marginRight} />
        Follow us on TikTok
      </ButtonV3>
      <ButtonV3
        component="a"
        href="https://www.instagram.com/zola"
        textTransform={false}
        target="_blank"
        rel="noopener noreferrer"
        size="large"
      >
        <BrandInstagramIcon width={20} height={20} css={marginRight} />
        Follow us on Instagram
      </ButtonV3>
    </ButtonsContainer>
  );

  return (
    <Container className={className}>
      <HedWrapper>
        <StyledH3>
          Hot takes and real truths <Accent>@Zola</Accent>
        </StyledH3>
        <div css={desktopOnly}>{renderButtons()}</div>
      </HedWrapper>
      <CategoryScroller>
        {imageData.map((image, idx) => (
          <Tile key={`${idx}-d`} href={image.href} target="_blank" rel="noopener noreferrer">
            {image.img}
          </Tile>
        ))}
      </CategoryScroller>
      <div css={excludeDesktop}>{renderButtons()}</div>
    </Container>
  );
};
export default SocialMediaSection;
